import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { ErpTableSkeleton } from './table-skeleton';

export interface ErpPageLoadingSkeletonProps extends HTMLAttributes<HTMLDivElement> {
  columns?: number;
  rows?: number;
}

export function ErpPageLoadingSkeleton({ columns = 10, rows = 10, className, ...props }: ErpPageLoadingSkeletonProps) {
  return (
    <div className={cn('flex h-full min-h-0 w-full flex-col bg-white', className)} {...props}>
      <div className='min-h-0 flex-1'>
        <ErpTableSkeleton columns={columns} rows={rows} showToolbar={false} />
      </div>
    </div>
  );
}
